import { dateFormat } from '@portal/utils/util-date';
import { guardUnspecified } from '@portal/utils/util-guards';
import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin, ObserverVisibility } from '@jtnews/shared';

import styles from './author-records-item.styles.scss?module';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface Events {
  onVisible: void;
  onClicked: void;
}

type BaseRecord = {
  publishAt?: string;
  header: string;
  urls: {
    url: string;
    urlCanonical: string;
    urlComments: string;
  };
};

type ComponentData = {
  itemObsVisibility: ObserverVisibility;
};

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'AuthorRecordsItem',
    props: {
      item: {
        type: Object as () => BaseRecord,
        required: true
      }
    },
    data(): ComponentData {
      return {
        itemObsVisibility: new ObserverVisibility('half')
      };
    },
    computed: {
      date(): string {
        if (!guardUnspecified(this.item.publishAt)) {
          return '';
        }

        try {
          return dateFormat(
            new Date(this.item.publishAt).toDateString(),
            'DD MMMM YYYY, HH:mm'
          );
        } catch (e) {
          return '';
        }
      }
    },
    mounted() {
      this.itemObsVisibility.event.subscribe((state: { isIntersecting: boolean }) => {
        if (state.isIntersecting) {
          this.onVisibleBlock();
        }
      });
    },
    beforeDestroy() {
      this.itemObsVisibility.destroy();
    },
    methods: {
      onVisibleBlock(): void {
        this.$emit('visible');
      },
      emitClicked(): void {
        this.$emit('clicked');
      }
    },
    render() {
      return (
        <div v-observe-visibility={this.itemObsVisibility.getOptions('half')}>
          <a
            class={styles.link}
            href={this.item.urls.url}
            target="_self"
            onClick={() => this.emitClicked()}
            domPropsInnerHTML={this.item.header}
          />
          <div class={styles.time}>{this.date}</div>
        </div>
      );
    }
  });
